import { render, staticRenderFns } from "./ImproveFiles.vue?vue&type=template&id=281b1654&scoped=true"
import script from "./ImproveFiles.vue?vue&type=script&lang=js"
export * from "./ImproveFiles.vue?vue&type=script&lang=js"
import style0 from "./ImproveFiles.vue?vue&type=style&index=0&id=281b1654&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281b1654",
  null
  
)

export default component.exports